exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".icon__1dWNqM6fzR {\n  color: #f99f10;\n}\n\n.icon__1dWNqM6fzR.padRight__7GycUdGNF6 {\n  margin-right: 5px;\n}\n", "",{"version":3,"sources":["Icons.scss"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","file":"Icons.scss","sourcesContent":[".icon {\n  color: #f99f10;\n}\n\n.icon.padRight {\n  margin-right: 5px;\n}\n"]}]);
// Exports
exports.locals = {
	"icon": "icon__1dWNqM6fzR",
	"padRight": "padRight__7GycUdGNF6"
};